import { type FC } from "react"
import { useFavorites } from "@/hooks/favorites"
import { Button } from "@/ui/Button/Button"
import { Modal } from "@/ui/Modal"
import { Buttons } from "./Buttons"

export const ClearListButton: FC = () => {
  const { clear, quantity } = useFavorites()

  if (quantity <= 0) {
    return null
  }

  const handleOk = () => {
    clear()
  }

  return (
    <Modal
      title="Очистить списки?"
      closeMode="destroy"
      disclosure={
        <Button icon={"Delete"} variant={"link"} isClean size={"smallM"}>
          Очистить все
        </Button>
      }
    >
      <Buttons onOk={handleOk} />
    </Modal>
  )
}
